import { ComponentProps } from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

/**
 * Just a wrapper around Sentry's ErrorBoundary component
 */
export const ErrorBoundary = (props: ComponentProps<typeof SentryErrorBoundary>) => {
  return <SentryErrorBoundary {...props}>{props.children}</SentryErrorBoundary>;
};
